/**
 *
 * BrowserDetection object is immediately executed when the page loads.
 * This Object is used to detect the browser and version the user is using.
 *
 * @namespace SearchLocalStorageService
 */
class SearchLocalStorageService {
    constructor() {
    }

    getRecentSearchData() {
        //check local storage for our search data
        if(localStorage.getItem("globalRecentSearches")) {
            return localStorage.getItem("globalRecentSearches");
        }
        return [];
    }

    setRecentSearchData(item) {
        var recentSearches = JSON.parse(localStorage.getItem("globalRecentSearches"));

        if(recentSearches) {
            //check for the same search value in array
            var tempArr = [];
            tempArr[0] = item;
            for(var i = 0; i < recentSearches.length; i++) {
                if(recentSearches[i].itemName != item.itemName) {
                    tempArr.push(recentSearches[i]);
                }
            }
            if(tempArr.length > 8) {
                tempArr = tempArr.slice(0, 8);
            }
            // var globalRecentSearches = tempArr;
            localStorage.setItem("globalRecentSearches", JSON.stringify(tempArr));
        } else {
            var globalRecentSearches = [item];
            localStorage.setItem("globalRecentSearches", JSON.stringify(globalRecentSearches));
        }
    }

    deleteRecentSearchData() {
        localStorage.removeItem("globalRecentSearches");
        console.log("deleted from service");
    }
}

export default new SearchLocalStorageService();



//////////////////
// WEBPACK FOOTER
// /Users/geoffsagers/dev/webcomponents/js/packages/common-account/node_modules/@nuskin/ns-util/src/SearchLocalStorageService.js
// module id = 310
// module chunks = 0